/* global System */
import withLazyUnveil from '../../higher-order-components/withLazyUnveil'

export default {
  ReportsTeaser: withLazyUnveil({
    loadComponent: () =>
      System.import(
        /* webpackChunkName: "ReportsTeaser" */
        './index'
      ),
    height: 715,
    mobileHeight: 630,
  }),
}
